import React, { useEffect, useRef, useState } from 'react';
import { GET } from '../../utils/apicalls';
import { API } from '../../config/api';

const containerStyle: React.CSSProperties = {
    height: '100vh',
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: '#000',
};

const mediaStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'opacity 0.8s ease-in-out',
    zIndex: 3,
    position: 'relative'
};

const descriptionOverlayStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    padding: '20px',
    fontSize: '20px',
    textAlign: 'center',
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)',
    color: '#fff',
    zIndex: 4,               // Higher than video
    pointerEvents: 'none',   // So it won't block video controls
};

function Videomanagement() {
    const [mediaList, setMediaList] = useState<any[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const timerRef = useRef<any>(null);

    useEffect(() => {
        const fetchMedia = async () => {
            try {
                const res: any = await GET(API.LIST_VIDEO_MANAGEMENT, {});
                if (res.status) {
                    setMediaList(res.data || []);
                }
            } catch (err) {
                console.error('Error loading media', err);
            }
        };

        fetchMedia();
    }, []);

    useEffect(() => {
        if (mediaList.length === 0) return;

        const currentItem = mediaList[currentIndex];
        const isVideo = currentItem.videomanagementVideo?.match(/\.(mp4|webm|ogg)$/i);

        if (isVideo) {
            const video = videoRef.current;
            if (video) {
                video.currentTime = 0;

                video
                    .play()
                    .catch((err) => console.warn("Autoplay error:", err));
                video.onended = () => moveToNext();
            }
        } else {
            timerRef.current = setTimeout(() => moveToNext(), 5000);
        }

        return () => {
            clearTimeout(timerRef.current);
            if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.onended = null;
            }
        };
    }, [currentIndex, mediaList]);

    const moveToNext = () => {
        setCurrentIndex((prev) => (prev + 1) % mediaList.length);
    };

    if (mediaList.length === 0) {
        return (
            <div style={{ display: 'none', }}>
                <img
                    src="/assets/no-video-placeholder.jpg"
                    alt="No media"
                    style={mediaStyle}
                />
                <div style={descriptionOverlayStyle} >No media available at the moment</div>
            </div>
        );
    }

    const current = mediaList[currentIndex];
    const isVideo = current.videomanagementVideo?.match(/\.(mp4|webm|ogg)$/i);

    return (
        <div style={containerStyle}>
            {isVideo ? (
                <video
                    ref={videoRef}
                    src={current.videomanagementVideo}
                    style={mediaStyle}
                    webkit-playsinline="true"
                    playsInline
                    controls
                />
            ) : (
                <img
                    src={current.videomanagementVideo}
                    alt={`media-${currentIndex}`}
                    style={mediaStyle}
                    className='banner-container'
                />
            )}

            {current.videomanagementDescription && (
                <div style={descriptionOverlayStyle}>{current.videomanagementDescription}</div>
            )}
        </div>
    );
}

export default Videomanagement;
